import Util from '../util';

const url = '/api/colorcalc/user_charts';
const Api = {
  /**
   * @param {object} params
   */
  getAsync({ x: center_x, y: center_y, radius}) {
    const queryString = Util.queryString({center_x, center_y, radius});
    return fetch(`${Util.apiSegment}${url}${queryString}`).then(response => response.json());
  }
};
export default Api;
